import React from 'react'
import { useNavigate } from 'react-router-dom'
import { createStyles, rem } from "@mantine/core";
import { removeCookie } from '../../utils';

const useStyles = createStyles((theme) => ({
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f9fafb',
    padding: '1rem',
  },
  contentBox: {
    maxWidth: rem(500),
    width: '100%',
    textAlign: 'center',
    backgroundColor: 'white',
    borderRadius: rem(8),
    boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
    padding: rem(48),
    "@media (max-width: 640px)": {
      padding: rem(32),
    }
  },
  iconBox: {
    margin: '0 auto',
    height: rem(48),
    width: rem(48),
    color: '#eab308',
    marginBottom: rem(16),
  },
  title: {
    fontSize: rem(20),
    fontWeight: 600,
    fontFamily: "Inter",
    color: '#1f2937',
    marginBottom: rem(16),
  },
  description: {
    fontSize: rem(16),
    fontWeight: 400,
    fontFamily: "Inter",
    color: '#6b7280',
    marginBottom: rem(24),
    lineHeight: 1.5,
  },
  button: {
    width: '100%',
    backgroundColor: '#FFAF4A',
    color: '#000',
    fontWeight: 500,
    fontFamily: "Inter",
    padding: `${rem(10)} ${rem(16)}`,
    borderRadius: rem(8),
    border: 'none',
    cursor: 'pointer',
    fontSize: rem(16),
    transition: 'background-color 0.2s',
    '&:hover': {
      backgroundColor: '#f1a84eff',
    },
  },
}));

export const FreePlanUsers = () => {
  const { classes } = useStyles();
  const navigate = useNavigate();

  const handleLogout = () => {
    removeCookie('token');    
    navigate('/home');
  };

  return (
    <div className={classes.container}>
      <div className={classes.contentBox}>
        <svg
          className={classes.iconBox}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
          />
        </svg>
        
        <h2 className={classes.title}>
          Subscription Required
        </h2>
        
        <p className={classes.description}>
          Your account is no longer subscribed to a package. Please inform your administrator to select a package.
        </p>
        
        <button
          onClick={handleLogout}
          className={classes.button}
        >
          Back to Home
        </button>
      </div>
    </div>
  );
};